import { useContext, ReactNode, useRef } from 'react';
import type { StoreApi } from 'zustand';
import { useStore as useZustandStore } from 'zustand';
import createStore from './createStore';
import { StoreProviderContext, StoreProviderContextType } from './store-provider-context';

export type StoreProviderProps = {
  children: ReactNode
};

export function StoreProvider({ children }:StoreProviderProps) {
  const store = useRef(createStore()).current;
  return <StoreProviderContext.Provider value={store}>{children}</StoreProviderContext.Provider>;
}

export function useStore(selector:(state:any) => any, equals?:any):any {
  const store = useContext<StoreProviderContextType>(StoreProviderContext);
  if (!store) throw new Error('Missing StoreProviderContext.Provider in the tree');
  return useZustandStore(store, selector, equals);
}

export function useStoreApi():any {
// export function useStoreApi<T>(): StoreApi<T extends (infer R) ? R: T> {
  const store = useContext<StoreProviderContextType>(StoreProviderContext);
  if (!store) throw new Error('Missing StoreProviderContext.Provider in the tree');
  return store;
}

export default StoreProvider;
